<template>
  <div>
    <functional-calendar
      :configs="calendarConfigs"
      name="date_range"
      ref="BookingCalendar"
      v-model="model"
    >
      <template v-slot:dateRangeInputs="props">
        <label for="check-in" :class="`booking-calendar-input-label`">
          <svg
            style="vertical-align: middle"
            width="21"
            height="23"
            viewBox="0 0 21 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.5493 8.73181H3.4507V20.2052H17.5493V8.73181ZM4.46948 19.1852V9.75184H16.5305V19.1852H4.46948Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.32394 0C4.66902 0 4.14085 0.53697 4.14085 1.19594V1.74645H1.52817C0.682665 1.74645 0 2.4398 0 3.29168V21.4548C0 22.3066 0.682665 23 1.52817 23H19.4718C20.3173 23 21 22.3067 21 21.4548V3.29168C21 2.4398 20.3173 1.74645 19.4718 1.74645H16.8592V1.19594C16.8592 0.53697 16.331 0 15.6761 0C15.0211 0 14.493 0.53697 14.493 1.19594V1.74645H6.50704V1.19594C6.50704 0.53697 5.97887 0 5.32394 0ZM5.12676 1.19594C5.12676 1.08328 5.21656 0.994718 5.32394 0.994718C5.43133 0.994718 5.52113 1.08328 5.52113 1.19594V3.29168C5.52113 3.40434 5.43133 3.4929 5.32394 3.4929C5.21656 3.4929 5.12676 3.40434 5.12676 3.29168V1.19594ZM15.4789 1.19594C15.4789 1.08328 15.5687 0.994718 15.6761 0.994718C15.7834 0.994718 15.8732 1.08328 15.8732 1.19594V3.29168C15.8732 3.40434 15.7834 3.4929 15.6761 3.4929C15.5687 3.4929 15.4789 3.40434 15.4789 3.29168V1.19594ZM0.985916 3.29168C0.985916 2.98611 1.23021 2.74117 1.52817 2.74117H4.14085V3.29168C4.14085 3.95065 4.66902 4.48762 5.32394 4.48762C5.97887 4.48762 6.50704 3.95065 6.50704 3.29168V2.74117H14.493V3.29168C14.493 3.95065 15.0211 4.48762 15.6761 4.48762C16.331 4.48762 16.8592 3.95065 16.8592 3.29168V2.74117H19.4718C19.7698 2.74117 20.0141 2.98611 20.0141 3.29168V5.93793H0.985916V3.29168ZM0.985916 21.4548V6.93265H20.0141V21.4548C20.0141 21.7603 19.7698 22.0053 19.4718 22.0053H1.52817C1.23021 22.0053 0.985916 21.7603 0.985916 21.4548Z"
              fill="black"
            />
          </svg>
          <input
            id="check-in"
            :class="`booking-calendar-input`"
            type="text"
            title="Start Date"
            name="start_date"
            :value="
              props.startDate
                ? moment(props.startDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
                : null
            "
            placeholder="Check In"
            :readonly="!props.isTypeable"
            valid-scope="booking-form"
          />
          <input
            type="hidden"
            name="start_date"
            :value="moment(props.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')"
          />
        </label>
        <label for="check-out" :class="`booking-calendar-input-label`">
          <svg
            style="vertical-align: middle"
            width="21"
            height="23"
            viewBox="0 0 21 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.5493 8.73181H3.4507V20.2052H17.5493V8.73181ZM4.46948 19.1852V9.75184H16.5305V19.1852H4.46948Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.32394 0C4.66902 0 4.14085 0.53697 4.14085 1.19594V1.74645H1.52817C0.682665 1.74645 0 2.4398 0 3.29168V21.4548C0 22.3066 0.682665 23 1.52817 23H19.4718C20.3173 23 21 22.3067 21 21.4548V3.29168C21 2.4398 20.3173 1.74645 19.4718 1.74645H16.8592V1.19594C16.8592 0.53697 16.331 0 15.6761 0C15.0211 0 14.493 0.53697 14.493 1.19594V1.74645H6.50704V1.19594C6.50704 0.53697 5.97887 0 5.32394 0ZM5.12676 1.19594C5.12676 1.08328 5.21656 0.994718 5.32394 0.994718C5.43133 0.994718 5.52113 1.08328 5.52113 1.19594V3.29168C5.52113 3.40434 5.43133 3.4929 5.32394 3.4929C5.21656 3.4929 5.12676 3.40434 5.12676 3.29168V1.19594ZM15.4789 1.19594C15.4789 1.08328 15.5687 0.994718 15.6761 0.994718C15.7834 0.994718 15.8732 1.08328 15.8732 1.19594V3.29168C15.8732 3.40434 15.7834 3.4929 15.6761 3.4929C15.5687 3.4929 15.4789 3.40434 15.4789 3.29168V1.19594ZM0.985916 3.29168C0.985916 2.98611 1.23021 2.74117 1.52817 2.74117H4.14085V3.29168C4.14085 3.95065 4.66902 4.48762 5.32394 4.48762C5.97887 4.48762 6.50704 3.95065 6.50704 3.29168V2.74117H14.493V3.29168C14.493 3.95065 15.0211 4.48762 15.6761 4.48762C16.331 4.48762 16.8592 3.95065 16.8592 3.29168V2.74117H19.4718C19.7698 2.74117 20.0141 2.98611 20.0141 3.29168V5.93793H0.985916V3.29168ZM0.985916 21.4548V6.93265H20.0141V21.4548C20.0141 21.7603 19.7698 22.0053 19.4718 22.0053H1.52817C1.23021 22.0053 0.985916 21.7603 0.985916 21.4548Z"
              fill="black"
            />
          </svg>
          <input
            id="check-out"
            :class="`booking-calendar-input`"
            name="end_date"
            type="text"
            title="End Date"
            :value="
              props.endDate
                ? moment(props.endDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
                : null
            "
            placeholder="Check Out"
            :readonly="!props.isTypeable"
            valid-scope="booking-form"
            v-validate="`required`"
          />
          <input
            type="hidden"
            name="end_date"
            :value="moment(props.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')"
          />
        </label>
      </template>
    </functional-calendar>
    <div>
      <label
        >{{ locales && locales.properties && locales.properties.upload_id }}
        <input
          type="file"
          name="document"
          accept="application/pdf, image/*"
          valid-scope="booking-form"
          v-validate="`required`"
      /></label>
    </div>
    <template
      v-if="
        model && model.dateRange && model.dateRange.start && model.dateRange.end
      "
    >
      <div>
        <p>
          {{
            moment(model.dateRange.end, "DD/MM/YYYY").diff(
              moment(model.dateRange.start, "DD/MM/YYYY"),
              "days"
            ) + 1
          }}
          {{ locales && locales.common && locales.common.days }}
        </p>
        <div class="booking-form__row d-flex --aligned-horizontally">
          <strong
            >{{
              locales && locales.properties && locales.properties.price
            }}:</strong
          >
          <span class="right-aligned">€ {{ bookPrice.toFixed(2) }}</span>
        </div>
        <div class="booking-form__row d-flex d-flex--aligned-horizontally"
          v-for="(item, index) in extraPrices"
          :key="index"
        >
          <strong>{{ item.name }}:</strong>
          <span class="right-aligned"
            >€ {{ getPeriodPrice(item.price, "month").toFixed(2) }}</span
          >
        </div>
        <hr />
        <div class="booking-form__row d-flex d-flex--aligned-horizontally">
          <strong>{{ locales && locales.common && locales.common.total }}:</strong>
          <span class="right-aligned">€ {{ total.toFixed(2) }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
import { FunctionalCalendar } from "vue-functional-calendar";
export default {
  inject: ["$validator"],
  components: { FunctionalCalendar },
  computed: {
    ...mapGetters(["locales"]),
    bookPrice: function () {
      var start = new Date(
        moment(this.model.dateRange.start, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var end = new Date(
        moment(this.model.dateRange.end, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var periodPrice = 0;
      if (this.model.dateRange.start && this.model.dateRange.end) {
        var period = this.countPeriod(this.period, start, end);
        var price = parseFloat((this.periodPrice + "").replace(",", "."));
        periodPrice = Math.round(price * period * 100) / 100;
      }
      return periodPrice;
    },
    total: function () {
      var t = 0;
      t += this.bookPrice;
      for (const [key, item] of Object.entries(this.extraPrices)) {
        let itemPrice = this.getPeriodPrice(item.price, "month");
        t += itemPrice;
      }
      t = Math.round(t * 100) / 100;
      return t;
    },
  },
  data() {
    return {
      model: this.range,
      minDate: new Date(),
      calendarConfigs: {
        dateFormat: "dd/mm/yyyy",
        limits: {
          min: moment().format("DD/MM/YYYY"),
          max: moment().add("10", "y").format("DD/MM/YYYY"),
        },
        markedDates: this.disabledDates,
        disabledDates: this.disabledDates,
        isDateRange: true,
        isModal: true,
        minSelDays: this.minDays,
        maxSelDays: this.maxDays,
        isAutoCloseable: true,
        isMultiple: true,
        calendarsCount: 2,
        monthNames: this.months,
        dayNames: this.days,
      },
    };
  },
  props: {
    selectedDate: {
      default: null,
      type: String,
    },
    range: {
      default: {},
      type: Object,
    },
    disabledDates: {
      default: [],
      type: Array,
    },
    period: {
      default: "day",
      type: String,
    },
    periodPrice: {
      default: "",
      type: String,
    },
    extraPrices: {
      default: [],
      type: [Array, Object],
    },
    months: {
      default: [],
      type: [Array, Object],
    },
    days: {
      default: [],
      type: [Array, Object],
    },
    minDays: {
      default: false,
      type: [Number, Boolean],
    },
    maxDays: {
      default: false,
      type: [Number, Boolean],
    },
  },
  methods: {
    moment: function (date = null, format = null) {
      return moment(date, format);
    },
    countPeriod(period, startDate, endDate) {
      var diff = 0;
      if (period == "week") {
        let week = 24 * 60 * 60 * 1000 * 7; // hours*minutes*seconds*milliseconds
        let day = 24 * 60 * 60 * 1000;
        diff = Math.abs((startDate - endDate - day) / week);
      } else if (period == "day") {
        let day = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        diff = Math.ceil(Math.abs((startDate - endDate) / day)) + 1;
      } else if (period == "month") {
        var substract = 0;
        var monthPart = 0;
        if (startDate.getDate() > 1) {
          substract += 1;
          var lastDayOfMonth = new Date(
            startDate.getFullYear(),
            startDate.getMonth() + 1,
            0
          );
          monthPart +=
            (lastDayOfMonth.getDate() - startDate.getDate() + 1) /
            lastDayOfMonth.getDate();
        }
        var lastDayOfEndMonth = new Date(
          endDate.getFullYear(),
          endDate.getMonth() + 1,
          0
        );
        if (endDate.getDate() < lastDayOfEndMonth.getDate()) {
          substract += 1;
          monthPart += endDate.getDate() / lastDayOfEndMonth.getDate();
        }
        let startMonth = startDate.getMonth() + 1;
        let endMonth = endDate.getMonth() + 1;
        let startYear = startDate.getFullYear();
        let endYear = endDate.getFullYear();
        if (startYear < endYear) {
          endMonth += (endYear - startYear) * 12;
        }
        if (endMonth - startMonth + 1 > 0) {
          diff = endMonth - startMonth + 1 - substract + monthPart;
        } else {
          diff = monthPart;
        }
      }
      return diff;
    },
    getPeriodPrice(price, periodType) {
      var start = new Date(
        moment(this.model.dateRange.start, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var end = new Date(
        moment(this.model.dateRange.end, "DD/MM/YYYY").format("YYYY-MM-DD")
      );
      var period = this.countPeriod(periodType, start, end);
      let p =
        Math.round(parseFloat((price + "").replace(",", ".")) * period * 100) /
        100;
      return p;
    },
    clearForm() {
      this.model.dateRange.start = '';
      this.model.dateRange.end = '';
      $('[name="document"]').val('');
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/BookingForm.vue